import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EmailForm from '../Shared/EmailForm';

import {
  renderServerErrorMsg,
  renderFrontEndError,
  isIndividualInputValid,
  allInputsValid,
} from '../../../helpers/ValidationHelper';

class ConfirmationReminder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      email: '',
      error: {},
      validationError: {},
      buttonEnabled: false,
    };

    this.areInputsValid = this.areInputsValid.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderValidationError = this.renderValidationError.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const t = e.target;
    const obj = {};
    obj[e.target.id] = t.value;

    this.setState(obj, this.individualInputValid.bind(this, e.target));
  }

  areInputsValid(fieldsToValidate = []) {
    const validationError = allInputsValid(fieldsToValidate, this.state);
    this.setState({ validationError });
    return Object.values(validationError).filter(e => e).length === 0;
  }

  individualInputValid(target) {
    const key = target.id;
    const errors = isIndividualInputValid(target, this.state[key]);
    this.setState({ validationError: errors, buttonEnabled: !errors[key] });
  }

  handleSubmit(target) {
    const nodes = document.querySelectorAll(`#${target.id} input[type=text]`);

    if (this.areInputsValid(nodes)) {
      target.submit();
    }
  }

  renderValidationError(msg) {
    return renderFrontEndError(this.state.validationError, msg);
  }

  render() {
    return (
      <div className="email-form-wrapper">

        <h2>{this.props.title}</h2>
        <p>{this.props.blob}</p>

        <EmailForm
          authenticityToken={this.props.authenticityToken}
          handleSubmit={this.handleSubmit}
          renderValidationError={this.renderValidationError}
          onChange={this.onChange}
          formAction={this.props.formAction}
          newUserConfimationPath={this.props.newUserConfimationPath}
          newUserPasswordPath={this.props.newUserPasswordPath}
          buttonText={this.props.buttonText}
          buttonEnabled={this.state.buttonEnabled}
          attribute='email'
          {...this.state}
        />
        {renderServerErrorMsg(this.state.error, this.state.loading)}
      </div>
    );
  }
}

ConfirmationReminder.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  formAction: PropTypes.string.isRequired,
  newUserConfimationPath: PropTypes.string.isRequired,
  newUserPasswordPath: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  blob: PropTypes.string.isRequired,
};

export default ConfirmationReminder;
